module.exports = __webpack_public_path__ + "static/group5_3-7cd1e42e7bcd3d128268ceb3d602f1b3.webp";